import { useMutation } from '@tanstack/react-query';

import { autoSetupProperties } from '~/services/PropertiesService';

export function useAutoSetupProperties() {
  return useMutation({
    mutationFn: (file: File) => autoSetupProperties(file),
  });
}
